export default function hydrator(parameters, d, chart) {
    
}